/*
  Brilinton site frame intersections.
  Adds the small corner/intersection marks used by the section linework system.
  Collection mastheads are intentionally excluded from section linework.
*/
(function () {
  function directMarks(section) {
    return Array.prototype.filter.call(section.children || [], function (child) {
      return child.classList && child.classList.contains('intersecting');
    });
  }

  function isCollectionMastheadSection(section) {
    return Boolean(
      section && (
        (section.classList && (section.classList.contains('collection-hero-section') || section.classList.contains('rx-hero-section'))) ||
        (section.querySelector && section.querySelector('[data-collection-masthead]'))
      )
    );
  }

  function isFrameInertCollectionConfigurator(section) {
    return Boolean(
      section && section.querySelector &&
      section.querySelector('.studio-collection[data-studio-surface="collection"]')
    );
  }

  function applySiteFrameIntersections() {
    var main = document.getElementById('MainContent');
    if (!main) return;

    var positions = [
      'top-left-vertical', 'top-left-horizontal',
      'top-right-vertical', 'top-right-horizontal',
      'bottom-left-vertical', 'bottom-left-horizontal',
      'bottom-right-vertical', 'bottom-right-horizontal'
    ];

    var sections = Array.prototype.slice.call(main.querySelectorAll('.shopify-section'));

    sections.forEach(function (section, index) {
      var masthead = isCollectionMastheadSection(section);
      var frameInertConfigurator = isFrameInertCollectionConfigurator(section);
      var followsMasthead = false; // The following content section owns its own top divider.
      var marks = directMarks(section);

      /* Full-bleed collection banners and zero-height collection configurator
         wrappers do not own visible in-page surfaces, so neither may generate
         site-frame rules/intersections. This prevents the configurator's bottom
         marks from collapsing upward onto the masthead edge as a visible +. */
      if (masthead || frameInertConfigurator) {
        marks.forEach(function (mark) { mark.remove(); });
        section.dataset.siteFrameIntersections = masthead
          ? 'collection-masthead-skipped'
          : 'collection-configurator-skipped';
        return;
      }

      /* The contextual section immediately below a collection banner can keep
         normal bottom linework, but never draws top intersections into the
         banner boundary. */
      if (followsMasthead) {
        marks.forEach(function (mark) {
          if (/^top-/.test(Array.prototype.find.call(mark.classList, function (name) { return /^top-/.test(name); }) || '')) {
            mark.remove();
          }
        });
      }

      if (section.dataset.siteFrameIntersections === 'true') return;
      section.dataset.siteFrameIntersections = 'true';

      positions.forEach(function (position) {
        if (followsMasthead && position.indexOf('top-') === 0) return;
        var span = document.createElement('span');
        span.className = 'intersecting ' + position;
        span.setAttribute('aria-hidden', 'true');
        section.appendChild(span);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applySiteFrameIntersections);
  } else {
    applySiteFrameIntersections();
  }

  document.addEventListener('shopify:section:load', applySiteFrameIntersections);
})();
